import type { ProfessionalData } from "@/entities/professional";

export type CompleteHealthProfessionalData = ProfessionalData & {
  readonly health_professional: true;
  readonly id_profession: number;
  readonly id_registration_type: number;
  readonly registration_number: string;
  readonly document_number: string;
};

export const isCompleteHealthProfessionalData = (
  data: ProfessionalData | undefined,
): data is CompleteHealthProfessionalData =>
  data?.health_professional === true &&
  data.id_profession !== null &&
  data.id_registration_type !== null &&
  data.registration_number !== null &&
  data.document_number !== null;

export const toUpdateProfessionalDataFormData = (
  professionalData: CompleteHealthProfessionalData,
  signature: File,
): FormData => {
  const formData = new FormData();

  formData.append("name", professionalData.name.trim());
  formData.append("surname", professionalData.surname.trim());
  formData.append("health_professional", "true");
  formData.append("id_profession", String(professionalData.id_profession));
  formData.append(
    "id_registration_type",
    String(professionalData.id_registration_type),
  );
  formData.append(
    "registration_number",
    professionalData.registration_number.trim(),
  );
  formData.append("document_number", professionalData.document_number.trim());
  formData.append("image", signature);

  return formData;
};
